import React from "react";
import { styled } from "@mui/material/styles";
import {
  Breadcrumbs as MuiBreadcrumbs,
  BreadcrumbsProps as MuiBreadcrumbsProps
} from "@mui/material";

export interface BreadcrumbsProps extends MuiBreadcrumbsProps {}

export function Breadcrumbs({
  separator = ">",
  ...rest
}: BreadcrumbsProps): JSX.Element {
  return <StyledBreadcrumbs separator={separator} {...rest} />;
}

const StyledBreadcrumbs = styled(MuiBreadcrumbs)`
  font-size: 18px;
  color: inherit;

  a {
    color: ${props => props.theme.palette.primary.main};
  }

  a:hover {
    text-decoration: underline;
  }
`;
